<ng-container>
  <div class="d-flex align-items-center">
    <!-- View/Info Icon Section -->
    @switch (!!currentConfig?.viewData) {
      @case (true) {
        <i class="ms-3 fas fa-eye" (click)="onViewDataClick()"> </i>
      }
      @case (false) {
        <i class="ms-3 fas fa-info-circle" [title]="fileStatsMessage"> </i>
      }
    }

    <!-- Download Icon Section -->
    @if (!currentConfig?.viewData && currentConfig?.downloadURL) {
      <i
        class="fas fa-download download-icon p-2 pt-3"
        (click)="!isDownloading && onDownloadClick()"
        [class.disabled]="isDownloading"
        [attr.disabled]="isDownloading ? true : null"
      >
      </i>
    }

    <!-- Delimiter and File Upload Section -->
    @if (currentConfig?.delimiter) {
      <mat-form-field
        class="ms-1 delimiter"
        [ngClass]="{ 'ui-disabled': readOnly }"
      >
        <mat-label>Delimiter</mat-label>
        <input matInput class="text-center" [(ngModel)]="delimiter" />
      </mat-form-field>
      <div [ngClass]="{ 'ui-disabled': readOnly }">
        <input
          [id]="inputId"
          type="file"
          style="display: none"
          [accept]="currentConfig?.acceptedFileType || '.csv'"
          (change)="onFileSelect($event)"
        />
        <label
          [for]="inputId"
          class="ra-blue-btn mt-1 ms-4 mx-1 mat-button mat-mdc-raised-button"
        >
          Choose File
        </label>
      </div>
    }
  </div>
</ng-container>
